// extracted by mini-css-extract-plugin
module.exports = {"gameContainer":"game_gameContainer__x6Kh8"};